import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TOnlineBankWithProvider } from './BankSelectionModal.types';
import { ChooseBank } from './ChooseBank';
import { ConnectBank } from './ConnectBank';

export const BankSelectionModal = ({
    isOpen,
    onClose
}: {
    isOpen: boolean;
    onClose: () => void;
}) => {
    const [selectedBank, setSelectedBank] =
        useState<TOnlineBankWithProvider | null>(null);

    const selectBank = (bank: TOnlineBankWithProvider) => {
        tracking.ampli.trueLayerBankSelection({
            bankId: bank.bank_id,
            bankName: bank.bank_name
        });

        setSelectedBank(bank);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            closeIcon={true}
            headerBar={true}
            title={
                <FormattedMessage
                    id="_.bank_selection_modal.title"
                    defaultMessage="Connect your business account"
                />
            }
            data-testid="bank-selection-modal"
            className="fs-mask dd-privacy-mask"
        >
            {selectedBank ? (
                <ConnectBank
                    selectedBank={selectedBank}
                    unselectBank={() => setSelectedBank(null)}
                />
            ) : (
                <ChooseBank selectBank={selectBank} />
            )}
        </Modal>
    );
};
